import { getType } from './bll';

/**
 * receives XML DOM object, returns converted JSON object
 * @param {*} xmlDoc xml节点对象
 * @param {*} opts 转换参数{format:自定义值的格式化方法，为空默认方法}
 */
const setJsonObj = (xmlDoc, opts) => {
  let js_obj = {};

  switch (xmlDoc.nodeType) {
    case 1:
      // 取出属性
      if (xmlDoc.attributes.length > 0) {
        // 属性定义
        js_obj['@attributes'] = {};
        for (let j = 0; j < xmlDoc.attributes.length; j++) {
          let attribute = xmlDoc.attributes.item(j);
          // console.log('attr', attribute);
          js_obj['@attributes'][attribute.nodeName] = attribute.value;
        }
      }
      break;
    case 3:
      if (opts.format) {
        // 是否格式化处理，字符
        js_obj = opts.format(xmlDoc.nodeValue);
      } else {
        js_obj = xmlDoc.nodeValue;
      }
      break;
  }

  // 下级节点
  if (xmlDoc.hasChildNodes()) {
    for (let i = 0; i < xmlDoc.childNodes.length; i++) {
      let item = xmlDoc.childNodes.item(i);
      let nodeName = item.nodeName;
      let _nodeValue = setJsonObj(item, opts);
      // console.log('node', nodeName, _nodeValue);
      if (nodeName == '#text' && _nodeValue == '') {
        // 没有内容，就跳过
        continue;
      }

      // console.log('nodeName', nodeName);
      if (typeof js_obj[nodeName] == 'undefined') {
        //没有当前属性
        js_obj[nodeName] = _nodeValue;
      } else {
        // 已经有值
        if (typeof js_obj[nodeName].push == 'undefined') {
          let old = js_obj[nodeName];
          js_obj[nodeName] = [];
          js_obj[nodeName].push(old);
        }
        js_obj[nodeName].push(_nodeValue);
      }
    }
  }

  return js_obj;
};

/**
 * 值格式化处理
 * @param {*} val 值内容
 */
const getValueFormat = function(val) {
  //  console.log(typeof val, val);
  // let rejsn = JSON.stringify(js_obj, undefined, 2)
  let rejsn = typeof val !== 'string' ? JSON.stringify(val, undefined, 2) : val;
  rejsn = rejsn.replace(/(^\s*)|(\s*$)/g, '');
  rejsn = rejsn
    .replace(/(\\t|\\r|\\n)/g, '')
    .replace(/"",[\n\t\r\s]+""[,]*/g, '')
    .replace(/(\n[\t\s\r]*\n)/g, '')
    .replace(/[\s\t]{2,}""[,]{0,1}/g, '')
    .replace(/"[\s\t]{1,}"[,]{0,1}/g, '');
  // console.log('nodeValue', typeof val, val, rejsn);
  return rejsn;
  // return rejsn.indexOf('"parsererror": {') == -1 ? rejsn : 'Invalid XML format';
};

/**
 * 转为json 对象
 * @param {*} xml 内容
 * @param {*} opts 输出的格式配置参数
 * opts:{format:内容格式化方法,默认去除空格，换行等}
 */
const toJson = (xml, opts) => {
  opts = opts || {
    //  内容格式化方法
    format: getValueFormat,
  };

  let xmlDoc;
  // for non IE browsers
  if (window.DOMParser) {
    // 加载内容
    xmlDoc = new DOMParser().parseFromString(xml, 'text/xml');
  } else {
    // for Internet Explorer
    xmlDoc = new ActiveXObject('Microsoft.XMLDOM');
    xmlDoc.async = 'false';
  }

  return setJsonObj(xmlDoc, opts);
};

/**
 * 类库解析
 * @param {*} item 
 */
const toCoreClass = item => {
  let _ret = {};

  if (item.summary) {
    // 注释描述
    _ret.summary = item.summary['#text'] || '';
  }
  return _ret;
};

/**
 * 方法解析
 * @param {*} item 
 * @param {*} name 
 */
const toCoreBll = (item, name) => {
  let _ret = {};

  if (item.summary) {
    // 注释描述
    _ret.summary = item.summary['#text'] || '';
  }

  // 取出参数类型
  let _attrs = [];
  // const reg = /#ctor\(([\S\s\t]*?)\)/;
  // let _ar = reg.exec(name);
  let _ar = name.match(/\((.+?)\)/g); // 取() 小括号
  if (_ar) {
    //  console.log('ctor', _ar);
    // 名称去除属性
    // name = name.replace(_attrs[0], '');
    //System.IO.Stream,System.Func{System.String,System.String}
    let _str = _ar[0].replace(/\{(.+?)\}/g, ''); // 去除 {} 花括号，大括号
    // _str = _ar[1].replace(/\[(.+?)\]/g, ''); // 去除 [] 中括号
    // _str =  _ar[1].replace(/\((.+?)\)/g, ''); // 去除 () 小括号
    // 类型属性处理
    _attrs = _str.split(',');
    // console.log(_attrs);
  }

  // 去除参数
  name = name.replace('.#ctor', '');

  if (item.param) {
    // 注释参数
    _ret.parm = toCoreParam(item.param, _attrs);
  }

  return [name, _ret];
};

/**
 * 注释参数转换
 * @param {*} params 参数集合
 * @param {*} attrs 参数类型
 * 返回 {参数名:[类型,描述]}
 */
const toCoreParam = (params, attrs) => {
  let _param = [];

  function bindPar(it, attr) {
    //   console.log(it, 'bindPar', attr);
    let _par = {};
    // 参数名=类型,描述
    _par[it['@attributes'].name] = [attr || '', it['#text'] || ''];
    return _par;
  }
  // 传入参数
  if (getType(params) == 'array') {
    // 多个参数
    for (let p = 0; p < params.length; p++) {
      if (params[p]['@attributes']) {
        // 取出参数
        _param.push(bindPar(params[p], attrs[p]));
      }
    }
  } else {
    //  console.log('params', getType(params), params);

    if (params['@attributes']) {
      // 取出参数
      _param.push(bindPar(params, attrs[0]));
    }
  }

  return _param;
};

/**
 * 适配core注释,转为json
 * @param {*} jsonDoc toJson转换对象
 */
const toCore = jsonDoc => {
  const _obj = {};

  const _doc = jsonDoc.doc;

  //console.log(typeof jsonDoc, jsonDoc);

  // if(jsonObj)

  /**
   * 
   * 
  N - 命名空间。
  T - 类型，包括类、接口、结构体、枚举和委托。
  F - 字段。
  P - 属性。
  M - 方法，包括普通方法、构造函数和运算符重载。
  E - 事件。
  ! - 错误成员，一般是由于编译器无法识别指定的成员类型，例如 <see cref="MemberNotExists"/>，就会被编译器转换为<see cref="!:MemberNotExists"/>。
   */

  // 命名空间
  const _namesp = _doc.assembly.name['#text'];

  _obj[_namesp] = {};

  /**
   * 方法名称
   */
  let _class, _bll;
  // 循环子节点
  for (let i = 0; i < _doc.members.member.length; i++) {
    // 取出描述
    const _item = _doc.members.member[i];
    if (_item['@attributes']) {
      // 属性名
      const _name = _item['@attributes'].name;

      // 判断类型
      if (_name && _name.indexOf(':') == 1) {
        const _type = _name.substr(0, 1);

        switch (_type) {
          case 'T': //类型，包括类、接口、结构体、枚举和委托。
            _class = _name.replace(_type + ':' + _namesp + '.', '');
            _obj[_namesp][_class] = toCoreClass(_item);

            break;
          case 'M': //方法，包括普通方法、构造函数和运算符重载。
            //QuickViewBLL.#ctor(System.IO.Stream,System.Func{System.String,System.String})
            _bll = _name.replace(_type + ':' + _namesp + '.', '');
            if (_bll) {
              const _ar = toCoreBll(_item, _bll);
              // console.log(_ar);
              _bll = _ar[0];
              _obj[_namesp][_class][_bll] = _ar[1];
            }
            break;

          case 'P': // 属性去除
            _bll = _name.replace(
              _type + ':' + _namesp + '.' + _class + '.',
              ''
            );
            if (_bll) {
              const _ar = toCoreBll(_item, _bll);
              //  console.log(_ar);
              _bll = _ar[0];
              _obj[_namesp][_class][_bll] = _ar[1];
            }
            break;
        }
      }
    }
  }

  return _obj;
};

export { toJson, toCore };
